import { axiosClient } from './axios_client';

export const inverter_model_api = {
  list: (params) => axiosClient.get('/api/inverter-models', { params }),
  getById: (id) => axiosClient.get(`/api/inverter-models/${id}`),
  create: (data) => axiosClient.post('/api/inverter-models', data),
  update: (id, data) => axiosClient.put(`/api/inverter-models/${id}`, data),
  remove: (id) => axiosClient.delete(`/api/inverter-models/${id}`),
};
